import { ViewOptionContextProvider, createUseViewOptions } from "@poscon/shared-frontend";
import type { EdstView } from "types/edstView";
import type { ViewOptionState } from "~redux/slices/viewOptionSlice";

export { ViewOptionContextProvider };

export const useViewOptions = createUseViewOptions<EdstView, ViewOptionState>();
